import { render } from "./searchUsers.vue?vue&type=template&id=5ec763e6"
import script from "./searchUsers.vue?vue&type=script&lang=js"
export * from "./searchUsers.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_laravelProjects\\2sport\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__